<template>
  <div id="root">
    <div :class="cssClasses">
      <component
        :is="$route.meta.layout"
        :title="title"
        :is-x-small="screen.getScreenSizeInfo.isXSmall"
        :is-large="screen.getScreenSizeInfo.isLarge"
      >
        <router-view></router-view>
        <template #footer>
          <app-footer />
        </template>
      </component>
    </div>
  </div>
</template>

<script setup>
import AppFooter from "./components/app-footer";
import { sizes, subscribe, unsubscribe } from "./utils/media-query";
import {
  getCurrentInstance,
  reactive,
  onMounted,
  onBeforeUnmount,
  computed
} from "vue";

import { useLocalization } from "@/locales/localization";
const localization = useLocalization();

import { useAuthStore } from "@/stores/auth.js";
const auth = useAuthStore();

import { themeService } from "./theme-service";

function getScreenSizeInfo() {
  const screenSizes = sizes();

  return {
    isXSmall: screenSizes["screen-x-small"],
    isLarge: screenSizes["screen-large"],
    cssClasses: Object.keys(screenSizes).filter(cl => screenSizes[cl])
  };
}

const vm = getCurrentInstance();

var title = "Portal";
const screen = reactive({ getScreenSizeInfo: {} });
screen.getScreenSizeInfo = getScreenSizeInfo();

function screenSizeChanged () {
  screen.getScreenSizeInfo = getScreenSizeInfo();
}

onMounted(() => {
  subscribe(screenSizeChanged);
  setLocale();
  title = localization.t('general.title');
  themeService.initAppTheme();
});

onBeforeUnmount(() => {
  unsubscribe(screenSizeChanged);
});

const cssClasses = computed(() => {
  return ["app"].concat(screen.getScreenSizeInfo.cssClasses);
});

function setLocale() {
  if (auth.user != null && auth.user.preferredLanguageCode != null) {
    localization.localeSet(auth.user.preferredLanguageCode);
  }
}
</script>

<style lang="scss">
html,
body {
  margin: 0px;
  min-height: 100%;
  height: 100%;
}

#root {
  height: 100%;
}

* {
  box-sizing: border-box;
}

.app {
  display: flex;
  height: 100%;
  width: 100%;
}
</style>
